export class ColourRampFilter extends PIXI.Filter<any> {
    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform sampler2D uRamp;

        void main() {
            vec4 pattern = texture2D(uSampler, vTextureCoord);
            vec4 ramp = texture2D(uRamp, vec2(pattern.r / max(pattern.a, 0.01), 0));
            gl_FragColor = vec4(ramp.rgb * pattern.a, pattern.a);
        }
    `;

    constructor(pRamp: PIXI.Texture) {
        super(undefined, ColourRampFilter.FRAG);
        this.uniforms.uRamp = pRamp;
    }
}
